import { Controller } from "stimulus"
import Chart from 'chart.js/auto';
import pieChartLegend from '../charts/pie_chart_legend';

const { buildPieChartLegendItems, renderPieChartLegend } = pieChartLegend;

export default class extends Controller {
  static targets = ["content", "legend"];

  connect() {
    const keys = JSON.parse(this.data.get("keys"));
    const datasets = JSON.parse(this.data.get("datasets"));
    const colors = JSON.parse(this.data.get("colors"));

    this.chart = new Chart(this.contentTarget, {
      type: 'doughnut',
      data: {
        labels: keys,
        datasets: [{
          label: '',
          data: datasets,
          backgroundColor: colors,
          borderColor: '#FFFFFF',
          borderWidth: 2,
          hoverBorderColor: '#FFFFFF',
          hoverBorderWidth: 2,
          hoverOffset: 4,
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        cutout: '65%',
        plugins: {
          legend: {
            display: !this.hasLegendTarget,
            position: 'bottom',
            align: 'start',
            labels: pieChartLegend()
          },
          tooltip: {
            backgroundColor: '#0E1110',
            titleColor: '#DDDDD6',
            bodyColor: '#FFFFFF',
            titleFont: { size: 12, weight: '600' },
            bodyFont: { size: 15, weight: '700' },
            padding: 12,
            cornerRadius: 8,
            displayColors: true,
            boxPadding: 4,
          },
        },
      }
    });

    if (this.hasLegendTarget) {
      const items = buildPieChartLegendItems(keys, colors);
      renderPieChartLegend(this.legendTarget, this.chart, items);
    }
  }

  disconnect() {
    if (this.chart) this.chart.destroy();
  }
}
